
<template>
  <div>
    <div class="complementary py-5">
      <div
        id="complementary"
        class="container pb-0"
        role="complementary"
      >
        <div class="row justify-md-space-between align-md-start">
          <div class="informations col-md-4 col-12">
            <div class="image">
              <p>
                <a href="https://www.dosatron.com">
                  <img
                    alt=""
                    class="logo"
                    src="/assets/logo-light.svg"
                    width="300"
                    height="45"
                  />
                </a>
              </p>
            </div>

            <p>
              <smalL>{{ $tc('footer.copyright.line1', [year]) }}</smalL>
            </p>

            <div class="image">
              <a href="https://company.ingersollrand.com/company.html" target="_blank">
                <img alt="" src="/assets/logo-ir2.png" width="200" height="70" />
              </a>
            </div>

          </div>

          <div class="col-md-7 col-12">

            <div class="row justify-md-center align-sm-start">
              <div class="col-md-7 col-sm-7 col-12">
                
                <p class="font-weight-bold mb-2">{{$t('footer.col.title')}}</p>

                <ul class="row list-unstyled mx-0 mt-2 mb-3 pl-0">
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'Help' }">{{$t('menu.help.title')}}</router-link></li>
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'MediaLibrary' }">{{$t('menu.mediaLibrary.title')}}</router-link></li>
                </ul>
                <ul class="row list-unstyled mx-0 pl-0">
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'SingleMarkets', params: { market: 'al' } }">{{$t('theme.al')}}</router-link></li>
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'SingleMarkets', params: { market: 'gl' } }">{{$t('theme.gl')}}</router-link></li>
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'SingleMarkets', params: { market: 'wl' } }">{{$t('theme.wl')}}</router-link></li>
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'SingleMarkets', params: { market: 'il' } }">{{$t('theme.il')}}</router-link></li>
                  <li class="col-6 pa-0 body-2"><router-link :to="{ name: 'SingleMarkets', params: { market: 'fl' } }">{{$t('theme.fl')}}</router-link></li>
                </ul>

                <p class="font-weight-bold mt-4 mb-2">{{$t('footer.col.title2')}}</p>

                <ul class="row list-unstyled mx-0 pl-0">
                  <li class="col-6 pa-0 body-2"><a href="https://smartdosing.dosatron.com" target="_blank">SmartDosing</a></li>
                  <li class="col-6 pa-0 body-2"><a href="https://dosatron.tv" target="_blank">Dosatron.tv</a></li>
                </ul>

              </div>
              <div class="informations col-md-5 col-sm-5 col-12">
                <p class="font-weight-bold mb-2">{{$t('footer.col.title3')}}</p>
                <p class="body-2">
                  <a
                    target="_blank"
                    href="https://goo.gl/maps/Z5RJi5zkJtV697af6"
                    class="d-flex align-center mb-3"
                  >
                    <v-icon large class="icon mr-3">mdi-map-marker</v-icon>
                    <span>Rue Pascal<br/>
                    33370 Tresses - FRANCE</span>
                  </a>
                  <a
                    href="tel:33557971111"
                    class="d-flex align-center mb-3"
                  >
                    <v-icon large class="icon mr-3">mdi-phone</v-icon>
                    <span>+33 05 57 97 11 11</span>
                  </a>
                  <a
                    href="mailto:info@dosatron.com"
                    class="d-flex align-center mb-3"
                  >
                    <v-icon large class="icon mr-3">mdi-email</v-icon>
                    <span>info@dosatron.com</span>
                  </a>
                </p>
                <ul class="social list-unstyled d-inline-flex pl-0 mb-0 mt-1">
                  <li>
                    <a
                      class="pa-1"
                      href="https://www.facebook.com/DosatronOfficialPage"
                      target="_blank"
                      :title="$t('follow.facebook')"
                    >
                      <v-icon large>mdi-facebook</v-icon>
                    </a>
                  </li>
                  <li>
                    <a
                      class="pa-1"
                      href="https://www.linkedin.com/company/dosatron"
                      target="_blank"
                      :title="$t('follow.linkedin')"
                    >
                      <v-icon large>mdi-linkedin</v-icon>
                    </a>
                  </li>
                  <li>
                    <a
                      class="pa-1"
                      href="https://www.instagram.com/dosatronofficial"
                      target="_blank"
                      :title="$t('follow.instagram')"
                    >
                      <v-icon large>mdi-instagram</v-icon>
                    </a>
                  </li>
                  <li>
                    <a
                      class="pa-1"
                      href="https://www.youtube.com/channel/UCo_oQmDkULTi6inz-L6BhpA"
                      target="_blank"
                      :title="$t('follow.youtube')"
                    >
                      <v-icon large>mdi-youtube-tv</v-icon>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="contentinfo py-5">
      <footer class="container d-md-flex justify-md-center align-md-center text-md-center pt-4 pb-4">
        <p class="body-2 mb-0">
          {{ $tc('footer.copyright.line2', [year]) }}{{ " " }}
          <span class="d-block d-md-inline-block mt-0">
            <router-link :to="{ name: 'Contact' }">
              {{$t('menu.contact.title')}}
            </router-link>
          </span>
        </p>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContentInfo',
  data () {
    return {
      year: 2020
    }
  }
}
</script>
<style>
.list-unstyled {
  list-style-type: none;
  padding-left: 0;
}
.complementary {
  background: #303131;
  color: #fff;
}
.complementary a {
  border-bottom: 0;
  text-decoration: none;
  color: #fff;
}
.complementary a:hover,
.complementary a:focus {
  text-decoration: underline;
}
.complementary .informations a {
  color: transparent !important;
}
.complementary .informations a span {
  color: #fff !important;
}
.complementary .informations a:hover span,
.complementary .informations a:focus span {
  text-decoration: underline;
}
.complementary hr {
  color: #1d1d1b;
  background: #1d1d1b;
  border-color: #1d1d1b;
  border-style: solid;
  border-width: 1px;
}
.complementary .theme--light.v-icon {
  color: #70787c;
}
.complementary a:hover .theme--light.v-icon,
.complementary a:focus .theme--light.v-icon {
  color: #fff;
}
.contentinfo {
  background: #1d1d1b;
  /* border-top: 1px solid #fff; */
  color: #fff;
}
/* .contentinfo footer + footer {
  border-top: 1px solid #fff;
} */
.contentinfo a {
  border-bottom: 0;
  text-transform: none;
  color: #fff;
}
.contentinfo a:hover,
.contentinfo a:focus,
.contentinfo a:hover i,
.contentinfo a:focus i {
  color: #70787c;
}
.social {
  position: relative;
  left: -8px;
}
.social li {
  display: block;
}
.social a {
  display: flex;
  align-items: center;
  color: transparent !important;
}
.social a:hover,
.social a:focus {
  /* background: #fff; */
  color: transparent !important;
}
</style>
